import { render, staticRenderFns } from "./SurveyProgressBar.vue?vue&type=template&id=6b3a5fa2"
import script from "./SurveyProgressBar.vue?vue&type=script&lang=js"
export * from "./SurveyProgressBar.vue?vue&type=script&lang=js"
import style0 from "./SurveyProgressBar.vue?vue&type=style&index=0&id=6b3a5fa2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports